import type { SetPriorityAction as SetPriorityActionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";

type PriorityOption = "URGENT" | "NONE";

const priorityOptions: RedoListItem<PriorityOption>[] = [
  { id: "URGENT", type: "text", text: "Urgent", value: "URGENT" },
  { id: "NONE", type: "text", text: "None (clear)", value: "NONE" },
];

export const SetPriorityAction = memo(function SetPriorityAction({
  action,
  onChange,
  editableFields,
}: {
  action: SetPriorityActionType;
  onChange: (updated: SetPriorityActionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const priorityEditable =
    editableFields === undefined || editableFields.has("priority");

  const selected = useMemo(() => {
    const value: PriorityOption =
      action.priority === "URGENT" ? "URGENT" : "NONE";
    return priorityOptions.find((opt) => opt.value === value);
  }, [action.priority]);

  return (
    <Flex dir="column" gap="md" w="full">
      <RedoSingleSelectDropdownInput<PriorityOption>
        disabled={!priorityEditable}
        fitToAnchor
        label="Priority"
        options={priorityOptions}
        optionSelected={({ item }) => {
          if (!priorityEditable) return;
          onChange({
            ...action,
            priority: item.value === "URGENT" ? "URGENT" : null,
          });
        }}
        selectedItem={selected}
      />
    </Flex>
  );
});
